import { jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import classNames from 'classnames';
import useResizeObserver from 'use-resize-observer';

const DashedLine = ({ className, direction = 'vertical' })=>{
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const { ref } = useResizeObserver({
        onResize: ({ width, height })=>{
            if (width === undefined || height === undefined) return;
            setWidth(width);
            setHeight(height);
        }
    });
    // Compute coordinates in middle of div
    const coordinates = useMemo(()=>{
        if (direction === 'vertical') {
            const x1 = width / 2;
            const y1 = 0;
            const x2 = x1;
            const y2 = height;
            return {
                x1,
                y1,
                x2,
                y2
            };
        }
        const x1 = 0;
        const y1 = height / 2;
        const x2 = width;
        const y2 = y1;
        return {
            x1,
            y1,
            x2,
            y2
        };
    }, [
        width,
        height,
        direction
    ]);
    return jsx("div", {
        ref: ref,
        className: classNames('cb-dashed-line', className),
        "data-testid": "dashed-line",
        children: jsx("svg", {
            id: "dashed",
            viewBox: `0 0 ${width} ${height}`,
            xmlns: "http://www.w3.org/2000/svg",
            children: jsx("line", {
                ...coordinates
            })
        })
    });
};
DashedLine.displayName = 'DashedLine';

export { DashedLine, DashedLine as default };
//# sourceMappingURL=DashedLine.es.js.map
